import * as Scrivito from "scrivito";
import { localizeAttrList } from "^/utils/localizeAttribute";
import imageWidgetIcon from "../../assets/images/image_widget.svg";

Scrivito.provideEditingConfig("ImageWidget", {
  title: "Image",
  thumbnail: imageWidgetIcon,
  attributes: localizeAttrList(
    ["alignment", "alternativeText", "link", "animation"],
    "ImageWidget"
  ),
  properties: [
    "animation",
    "alignment",
    "description",
    "alternativeText",
    "link",
    "width",
    "height",
    "blendMode",
  ],
  initialContent: {
    alignment: "left",
    animation: "none",
  },
});
